

import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { VueMaskDirective as mask } from "v-mask";
import GlobalMixin from "@/mixins/global";
import IBModal from "@/components/Modal/IBModal.vue";
import FieldValidatorByRules from "@/mixins/field/FieldValidatorByRules";
import FormOnChange from "@/components/Form/mixins/FormOnChange";
import MaskUtils from "@/modules/Mask/MaskUtils";

@Component({
	components: {
		IBModal
	},
	directives: {
		mask
	}
})
export default class DropdownLang extends Mixins(GlobalMixin, FieldValidatorByRules, FormOnChange) {
  private afterOpen: boolean = false;
  private selectedItem = null;

	@Prop({ type: String, default: "" }) readonly className!: string;

	@Prop({ type: String, default: "" }) readonly title!: string;

	@Prop({ type: String, default: "" }) readonly value!: string;

	@Prop({ type: String, default: "" }) readonly icon!: string;

	@Prop({ type: String, default: "" }) readonly heading!: string;

	@Prop(String) readonly prependIcon!: string;

	@Prop(String) readonly prependIconWidth!: string;

	@Prop(String) readonly cardNum!: string;

	@Prop({ type: String, default: "" }) readonly chipsChange!: string;

	@Prop({ type: Number, default: NaN }) readonly maxlength!: number;

	@Prop({ type: Number, default: NaN }) readonly minlength!: number;

	@Prop({ type: String, default: "text" }) readonly type!: string;

	@Prop({ type: String, default: "" }) readonly id!: string;

	@Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

	@Prop({ type: Boolean, default: false }) readonly senderAccountBalance!: boolean;

	@Prop(Boolean) readonly transparent!: boolean;

	@Prop(Boolean) readonly useTitleLikeLabel!: boolean;
	@Prop(Boolean) readonly accountField!: boolean;

	@Prop(Boolean) readonly useTitleLabel!: boolean;

	@Prop({ type: Boolean, default: false }) readonly filled!: boolean;

	@Prop({ type: Boolean, default: false }) readonly accountFilter!: boolean;

	@Prop({ type: Boolean, default: true }) readonly required!: boolean

	@Prop(Boolean) readonly withoutBorder!: boolean;

	@Prop({ type: Boolean, default: false }) readonly valid!: boolean;

	@Prop({ type: Boolean, default: true }) readonly readonly!: boolean;

	@Prop(Boolean) readonly nonSelectable!: boolean;

	@Prop({ type: Array, default: () => [] }) readonly chipsDropdown!: any[];

	@Prop({ type: String, default: '' }) readonly errorMessage!: string;

  @Prop({ type: Boolean, default: false }) readonly showAllChips!: false;

	public isBtnActive: boolean;
	public isFocus: boolean;
	public isActive: boolean;

	public inputText: string;

	public isActiveActionSheet: boolean;

	@Prop(Boolean)
	isFormItem!: boolean

	constructor() {
		super();

		this.isBtnActive = false;
		this.isActiveActionSheet = false;
		this.isFocus = false;
		this.isActive = false;

		this.inputText = "";
	}

	created() {
		this.setFromModel();
	}

	setFromModel(afterClose: boolean = false) {
		if(!this.value) return;

		const item = this.chipsDropdown.find(
			chips => chips.name === this.value
		);

    if (this.showAllChips && afterClose && this.selectedItem) {
      if (item) {
        this.selectedItem = item;
        this.dropdownChange(item);
      } else {
        this.dropdownChange(this.selectedItem);
      }
      return;
    }

		item && this.dropdownChange(item);
	}

	get filteredOptions() {
		let filter = this.chipsDropdown;

		if (this.inputText && !this.readonly && !this.afterOpen) {
			filter = filter.filter(item => item.name && item.name.toLowerCase().includes(this.inputText.toLowerCase()));
		}
		return filter;
	}

	keyPress(v: any) {
		this.$emit('keyPress', v.target.value);

    if (this.showAllChips && !this.readonly) {
      this.afterOpen = false;
    }
	}

	keyPaste(e: any) {
		if (!!this.mask) return this.$emit('keyPaste', MaskUtils.to(e.clipboardData.getData('text'), this.mask));

		this.$emit('keyPaste', e.clipboardData.getData('text'));
	}

	valueChanged(e: any) {
		this.$emit("input", e.target.value);
		this.inputText = e.target.value;

		if (this.accountFilter) {
			const val = e.target.value;

			if (val.length > 20) {
				e.target.value = val.slice(0, 20);
				this.inputText = val.slice(0, 20);
			}
		}
	}

	dropdownChange(value: any) {
    this.selectedItem = value;
		this.$emit("dropdownChange", value);
		this.$emit("input", value.name);
		this.inputText = this.useTitleLabel ? value.title : value.name;
		if (this.isSm) {
			this.clickInput();
		}

		this.$nextTick(() => this.isActiveActionSheet = false);
	}

	focusedInput(event: { type: string; }) {
		this.$emit("dropdownOpen");

		this.isFocus = event.type == "focus" && !this.readonly;

    if (event.type == "focus" && !this.readonly && this.showAllChips) {
      this.afterOpen = true;
    }

    if (event.type == 'blur' && this.showAllChips) {
      this.setFromModel(true);
    }
	}

	clickInput() {
		if (this.accountFilter) {
			this.inputText = '';
			this.$emit("click");
		}
		
		if (this.isSm && this.chipsDropdown.length) {
			this.isBtnActive = false;
			this.$emit("click");

			if (!this.readonly) return;

			this.isActiveActionSheet = !this.isActiveActionSheet;
		} else {
			this.isBtnActive = !this.isBtnActive;
		}
	}

	btnClick(e: any) {
		this.$emit("click", e);
	}

	onModelChange() {
		this.isFormItem && this.setFromModel();
		this.callOnChange(this.value);
		
		if (this.$route.name === 'SendingSwiftContentPath') {
			const item = this.chipsDropdown.find(chips => chips.name === this.value);
			this.selectedItem = item;
			this.inputText = item.title || item.name;
		}
	}

	get flagIconClass() {
		return "icon-" + this.icon.toLowerCase();
	}

	@Watch("chipsChange")
	changeText() {
		if (this.chipsChange === "") {
			this.inputText = "";
		}
	}

	@Watch('value')
	dropdownValueChanged() {
		this.onModelChange();
	}

	@Watch('isOpen')
	closeDropdownChange(isOpen: boolean): void {
		if (!isOpen) {
			document.removeEventListener('click', this.closeDropdown);
		} else {
			document.addEventListener('click', this.closeDropdown);
		}
	}

	closeDropdown(event: MouseEvent): void {
		if (!(this.$refs.dropdown as HTMLElement).contains(event.target as Node)) {
			if (!this.isBtnActive) return;

			this.isBtnActive = false;
		}
	}

	mounted(): void {
		document.addEventListener('click', this.closeDropdown);
	}

	beforeDestroy(): void {
		document.removeEventListener('click', this.closeDropdown);
	}

}
